import type { AppRouteRecordRaw, AppRouteModule } from '/@/router/types';

import { PAGE_NOT_FOUND_ROUTE, REDIRECT_ROUTE } from '/@/router/routes/basic';

import { mainOutRoutes } from './mainOut';
import { t } from '/@/utils/i18n';
import { RouteEnum } from '/@/enums/routeEnum';

const modules: Record<string, any> = import.meta.glob('./modules/**/*.ts', { eager: true });

const routeModuleList: AppRouteModule[] = [];

Object.keys(modules).forEach((key) => {
  const mod = modules[key].default || {};
  const modList = Array.isArray(mod) ? [...mod] : [mod];
  routeModuleList.push(...modList);
});

export const asyncRoutes = [PAGE_NOT_FOUND_ROUTE, ...routeModuleList];

export const RootRoute: AppRouteRecordRaw = {
  path: '/',
  name: 'Root',
  redirect: RouteEnum.RECENTS,
  meta: {
    title: 'Root',
  },
};

export const LoginRoute: AppRouteRecordRaw = {
  path: RouteEnum.BASE_LOGIN,
  name: RouteEnum.BASE_LOGIN,
  component: () => import('/@/views/sys/login/index.vue'),
  meta: {
    title: t('sys.login.loginTitle'),
    description: t('sys.login.loginDescription'),
  },
};

export const driveRoute: AppRouteRecordRaw = {
  path: '/oauth2/client',
  name: 'OAuth2',
  redirect: `/oauth2/client/success`,
  meta: {
    title: 'OAuth2',
  },
  children: [
    {
      path: 'success',
      name: 'DriveSuccess',
      component: () => import('/@/views/sys/redirect/DriveSuccess.vue'),
      meta: {
        title: '',
        // affix: true,
        hideMenu: true,
      },
    },
    {
      path: 'failure',
      name: 'DriveFailure',
      component: () => import('/@/views/sys/redirect/DriveFailure.vue'),
      meta: {
        title: '',
        // affix: true,
        hideMenu: true,
      },
    },
  ],
};

export const emailAuthentication: AppRouteRecordRaw = {
  path: RouteEnum.EMAIL_AUTHENTICATION,
  name: RouteEnum.EMAIL_AUTHENTICATION,
  component: () => import('/@/views/sys/emailAuthentication/index.vue'),
  meta: {
    title: t('routes.basic.emailAuthentication'),
  },
};

export const GoogleRedirectRoute: AppRouteRecordRaw = {
  path: RouteEnum.GOOGLE_REDIRECT,
  name: RouteEnum.GOOGLE_REDIRECT,
  component: () => import('/@/views/sys/login/global/GoogleRedirect.vue'),
  meta: {
    title: t('routes.basic.login'),
  },
};

export const ResetRoute: AppRouteRecordRaw = {
  path: RouteEnum.RESET_PAGE,
  name: RouteEnum.RESET_PAGE,
  component: () => import('/@/views/sys/login/global/ResetPage.vue'),
  meta: {
    title: t('common.resetText'),
  },
};

export const Preview: AppRouteRecordRaw = {
  path: RouteEnum.PREVIEW,
  name: RouteEnum.PREVIEW,
  component: () => import('/@/views/sys/preview/Preview.vue'),
  meta: {
    title: 'Preview',
  },
};

export const JoinTeamBridge: AppRouteRecordRaw = {
  path: RouteEnum.JOIN_TEAM_BRIDGE,
  name: RouteEnum.JOIN_TEAM_BRIDGE,
  component: () => import('/@/views/sys/JoinTeamBridge/index.vue'),
  meta: {
    title: 'Preview',
  },
};

export const PDFViewer: AppRouteRecordRaw = {
  path: RouteEnum.PDF,
  name: RouteEnum.PDF,
  component: () => import('/@/views/sys/preview/Pdf.vue'),
  meta: {
    title: 'Pdf',
  },
};

// Basic routing without permission
export const basicRoutes = [
  LoginRoute,
  GoogleRedirectRoute,
  RootRoute,
  ...mainOutRoutes,
  REDIRECT_ROUTE,
  PAGE_NOT_FOUND_ROUTE,
  ResetRoute,
  Preview,
  JoinTeamBridge,
  PDFViewer,
  emailAuthentication,
  driveRoute,
];
